import { createSelector } from 'reselect';
import { newBookingSelector } from './new-booking-selectors';

const bulkUploadSelector = state => state.bulkUpload;

export const bulkUploadDeliveryIDsSelector = createSelector(
  bulkUploadSelector,
  bulkUpload => bulkUpload.deliveryIDs,
);

export const bulkUploadDeliveriesSelector = createSelector(
  newBookingSelector,
  bulkUploadDeliveryIDsSelector,
  (nbs, deliveryIDs) =>
    deliveryIDs &&
    deliveryIDs
      .map(deliveryID => nbs.deliveryDetails[deliveryID])
      .filter(delivery => !!delivery),
);

export const bulkUploadMetaDataSelector = createSelector(
  bulkUploadSelector,
  bulkUpload => bulkUpload.metaData,
);

export const bulkUploadRawDataSelector = createSelector(
  bulkUploadSelector,
  bulkUpload => bulkUpload.rawData,
);

export const bulkUploadPOIsInitiatedSelector = createSelector(
  bulkUploadSelector,
  bulkUpload => bulkUpload.POIsInitiated,
);

export const bulkUploadOfferListSelector = createSelector(
  bulkUploadSelector,
  bulkUpload => bulkUpload.offerList,
);

export const bulkUploadFetchingPromoSelector = createSelector(
  bulkUploadSelector,
  bulkUpload => bulkUpload.fetchingPromo,
);

export const bulkUploadOfferConfigSelector = createSelector(
  bulkUploadSelector,
  bulkUpload => bulkUpload.offerConfig,
);

export const bulkUploadApplicableOfferConfigSelector = createSelector(
  bulkUploadSelector,
  bulkUpload => bulkUpload.applicableOfferConfig,
);

export const bulkUploadGroupingSelector = createSelector(
  bulkUploadSelector,
  bulkUpload => bulkUpload.grouping,
);

export const bulkUploadGroupingClusterMappingsSelector = createSelector(
  bulkUploadGroupingSelector,
  grouping => grouping.clusterMappings,
);

export const bulkUploadGroupingTrialDeliveriesSelector = createSelector(
  bulkUploadGroupingSelector,
  grouping => grouping.trialDeliveries,
);

export const bulkUploadGroupingFetchingQuoteSelector = createSelector(
  bulkUploadGroupingSelector,
  grouping => grouping.fetchingGroupQuote,
);

export const bulkUploadGroupingIsGroupedSelector = createSelector(
  bulkUploadGroupingSelector,
  grouping => grouping.isGrouped,
);
